import Footer from "../Footer/Footer";
import Logo from "../Logo/Logo";
import Sidebar from "../Sidebar/Sidebar";
import { Outlet } from "react-router-dom";
import "./ProtectedLayout.scss";
import { Topbar } from "../Topbar/Topbar";
import { LayoutProvider, useLayout } from "../../contexts/LayoutContext";
import { useCallback } from "react";

function ProtectedLayoutInner() {
  const { collapsed, setCollapsed, isMobile } = useLayout();

  const handleSidebarNavClick = useCallback(() => {
    // em mobile, ao clicar num item do menu, o menu tem de colapsar
    if (isMobile) {
      setCollapsed(true);
    }
  }, [isMobile, setCollapsed]);

  return (
    <>
      <main
        className="grid-protected-layout"
        data-collapsed={collapsed ? "true" : "false"}
      >
        <Logo collapsed={collapsed} />
        <Sidebar collapsed={collapsed} onNavClick={handleSidebarNavClick} />
        <Topbar />
        <Outlet />
      </main>
    </>
  );
}

export default function ProtectedLayout() {
  return (
    <LayoutProvider>
      <ProtectedLayoutInner />
    </LayoutProvider>
  );
}
